var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.179,
    height: 27.7,
    viewBox: "0 0 24.179 27.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.004 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.004 -0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M24.152,14.6c0,3.715-.039,7.43.023,11.143a1.907,1.907,0,0,1-1.928,1.945c-6.769-.037-13.54-.019-20.311-.021A1.713,1.713,0,0,1,.008,25.744C.01,18.37.031,10.984,0,3.608A3.54,3.54,0,0,1,3.631-.005c5.651.015,11.3,0,16.95,0a3.457,3.457,0,0,1,3.493,2.651,3.962,3.962,0,0,1,.075,1.1Q24.156,9.179,24.152,14.6ZM12.087,8.649a7.779,7.779,0,1,0,7.777,7.781A7.778,7.778,0,0,0,12.087,8.649Zm-7.349-2.6A1.35,1.35,0,0,0,6.05,4.739a1.35,1.35,0,0,0-1.3-1.274A1.35,1.35,0,0,0,3.415,4.753a1.35,1.35,0,0,0,1.323,1.3Zm5.205,0a1.35,1.35,0,0,0,1.294-1.284,1.319,1.319,0,0,0-2.635,0A1.35,1.35,0,0,0,9.945,6.052Z",
    transform: "translate(0.004 0.007)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M43.435,80.09a5.918,5.918,0,0,1-2.418,5.884,5.733,5.733,0,0,1-5.9.671,5.9,5.9,0,0,1-3.646-6.1c.023-.308.031-.463.386-.2a2.7,2.7,0,0,0,3.218,0,.574.574,0,0,1,.825.025,2.722,2.722,0,0,0,3.212-.039c.193-.15.351-.251.628-.071A2.811,2.811,0,0,0,43.435,80.09Z",
    transform: "translate(-25.385 -64.648)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestLaundry);
export default __webpack_public_path__ + "static/media/request-laundry.a83c9523c6a12a3d29237ab158f6da13.svg";
export { ForwardRef as ReactComponent };